import React from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { useNavigate, useLocation } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import ReleaseActions from 'reducers/Releases'
import { SidebarNavItem } from '@dsny/dsny-component-library'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'
import useArchiveToFilter from 'utils/hooks/useArchiveToFilter'

const navItems = [
  {
    name: 'sidebar.releases',
    route: '/releases',
    icon: 'Home',
    shouldShowInMobile: true
  },
  {
    name: 'sidebar.playlists',
    route: '/playlists',
    icon: 'LibraryMusic',
    shouldShowInMobile: false
  },
  {
    name: 'sidebar.flagged',
    route: '/flagged',
    icon: 'Flag',
    shouldShowInMobile: false
  },
  {
    name: 'sidebar.archived',
    route: '/archived',
    icon: 'Archive',
    shouldShowInMobile: false
  },
  {
    name: 'sidebar.history',
    route: '/recently_played',
    icon: 'Schedule',
    shouldShowInMobile: false
  }
]

function Navbar({ t, afterClick }) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useMobileMediaQuery()
  const { enabled: archiveToFilterEnabled, isLoading } = useArchiveToFilter()

  const handleItemClick = (navItem) => {
    navigate(navItem?.route)
    if (navItem.route === '/releases') {
      dispatch(ReleaseActions.setReleaseGalleryScrollPosition(0))
    }
    afterClick()
  }

  return (
    <nav style={{ paddingBottom: 36 }}>
      {navItems
        .filter(
          (item) =>
            item.route !== '/archived' ||
            (!archiveToFilterEnabled && !isLoading)
        )
        .map((navItem) => {
          const normalizedPath = location.pathname.replace(/\/+$/, '')
          const isActive = normalizedPath === navItem.route

          return (
            <SidebarNavItem
              key={navItem.name}
              as="button"
              onClick={() => handleItemClick(navItem)}
              label={t(navItem.name)}
              iconName={navItem.icon}
              isActive={isActive}
              setting="player"
              mode="desktop"
              style={{
                width: '100%',
                height: 40,
                marginBottom: 8,
                display:
                  isMobile && !navItem.shouldShowInMobile ? 'none' : 'flex'
              }}
              labelStyle={{ textAlign: 'left' }}
            />
          )
        })}
    </nav>
  )
}

Navbar.propTypes = {
  t: PropTypes.func.isRequired,
  afterClick: PropTypes.func.isRequired
}

export default withTranslation()(Navbar)
